(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodConsoleLog', sodConsoleLog);

    function sodConsoleLog() {
        return {
            restrict: 'E',
            scope: {
                value: '=',
            },
            link: function(scope) {
                console.log("### LOG ###");
                console.log(scope.value);
            }
        };
    }
})();